import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldPasswordComponent } from './field-password.component';
import { CardComponent } from '../../../@theme/components/card/card.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FieldPasswordRenderImagePipe } from './field-password-render-image.pipe';



@NgModule({
  declarations: [
    FieldPasswordComponent,
    FieldPasswordRenderImagePipe
  ],
  exports: [
    FieldPasswordComponent
  ],
  imports: [
    CommonModule,
    CardComponent,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule
  ]
})
export class FieldPasswordModule { }
